import styled from 'styled-components';

export const ShippingStatusFormStyled = styled.div`
  .identity {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 6px;
    margin-bottom: 16px;
    font-size: 13.5px;
    color: #64748b;
    .who {
      color: #1f2a37;
      font-weight: 500;
    }
    .dot {
      color: #c3ccd8;
    }
    .qty {
      background: #eef2f7;
      border-radius: 4px;
      padding: 1px 7px;
      font-size: 12.5px;
    }
  }

  /* สถานะเดิม -> สถานะใหม่ วางคู่กันให้เห็นว่ากำลังเปลี่ยนจากอะไรเป็นอะไร */
  .status_row {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    margin-bottom: 18px;
    .from_block {
      flex: 1;
      min-width: 0;
      padding: 9px 12px;
      background: #f4f6f9;
      border: 1px solid #e3e8ef;
      border-radius: 6px;
      .from_label {
        font-size: 11.5px;
        color: #8d99a8;
      }
      .from_value {
        font-size: 14px;
        color: #46566b;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    /* ชื่อคลาสต้องไม่ใช่ .arrow เพราะจะไปชนกับไอคอนลูกศรภายใน Inputs.Dropdown
       ที่อยู่ใน .to_block ทำให้ลูกศรของ dropdown เยื้องออกจากกึ่งกลาง */
    .status_arrow {
      padding-bottom: 10px;
      color: #b0bcca;
      flex: none;
    }
    .to_block {
      flex: 1.2;
      min-width: 0;
    }
  }

  @media (max-width: 520px) {
    .status_row {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
      .status_arrow {
        display: none;
      }
    }
  }

  .input_wrap {
    margin-bottom: 18px;
  }

  .notice {
    margin-bottom: 18px;
    padding: 10px 14px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.6;
    &.warn {
      background: #fff8e6;
      color: #8a6100;
    }
    &.stop {
      background: #fdecec;
      color: #9c2b2b;
    }
  }

  .action_row {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    .btn_item {
      width: 120px;
    }
  }

  .detail_block {
    margin-top: 22px;
    padding-top: 16px;
    border-top: 1px solid #e8ecf1;
    .detail_head {
      font-size: 12px;
      color: #8d99a8;
      margin-bottom: 10px;
    }
    .detail_grid {
      display: flex;
      flex-wrap: wrap;
      row-gap: 12px;
    }
    .info_item {
      width: 33.33%;
      padding-right: 12px;
      &.full {
        width: 100%;
        padding-right: 0;
      }
      .info_label {
        font-size: 11.5px;
        color: #97a3b2;
      }
      .info_value {
        font-size: 13.5px;
        color: #3c4a5c;
        word-break: break-word;
      }
    }
    @media (max-width: 520px) {
      .info_item {
        width: 50%;
      }
    }
  }
`;
